import React from "react";
import useMatchupStore from "../store/MatchupStore";
import { updateScoreboardHeader } from "../utils/matchupUtils";

export default function ProjStatsToggle() {
  const [showProjStats, setShowProjStats] = useMatchupStore((state) => [
    state.showProjStats,
    state.setShowProjStats,
  ]);

  const handleToggleClick = () => {
    setShowProjStats(!showProjStats);
    updateScoreboardHeader();
  };

  return (
    <button
      onClick={handleToggleClick}
      className="inline-flex touch-manipulation items-center justify-center px-1 -mx-1 md:px-0 md:mx-0"
    >
      <span
        className={`h4 mb-0 inline-flex gap-1.5 items-center justify-center rounded-full border py-2 px-2 md:px-3 text-center text-xs font-medium focus:ring-4 ${
          showProjStats
            ? "border-teal-500 text-teal-700 dark:text-gray-200 bg-teal-50  focus:ring-teal-100 dark:border-teal-900 dark:bg-teal-950/50  dark:focus:ring-teal-800"
            : "border-gray-300 bg-white text-gray-900 hover:bg-gray-100 focus:ring-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
        }`}
      >
        <span className="hidden md:inline">Projected</span>
        <svg
          className={`h-3.5 w-3.5 ${showProjStats ? "text-teal-700 dark:text-teal-400" : ""}`}
          viewBox="0 0 108 108"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54 4C54 31.6142 76.3856 54 104 54C76.3856 54 54 76.3856 54 104C54 76.3856 31.6142 54 4 54C31.6142 54 54 31.6142 54 4Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
}
